import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 800px;
  overflow: auto;

  .flow-user-timeline-header {
    position: relative;
    padding-top: 40px;

    > div:first-child > div:first-child {
      position: absolute;
      top: 2px;
      left: 20px;
      width: 100%;
    }
  }
`;

export const DashboardPanel = styled.div`
  background-color: #fff;
  padding-bottom: 10px;
`;

export const TimelineTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SessionTableTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-right: 12px;
`;
